module.exports = __webpack_public_path__ + "static/img/graficas.ce04340.png";